<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromJob" :rules="rules" ref="fromJob" class="demo-form-inline">
                <el-row :gutter="20">
                    <el-col>
                        <td-permission :oneOfPermissions="permissionsQuery">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.JOB_NAME')" prop="jobName">
                                    <td-input v-model="fromJob.jobName" :maxlength="inputLength"></td-input>
                                </el-form-item>
                                <el-form-item :label="$t('common.RUNSTATUS')" prop="runState">
                                    <td-select v-model="fromJob.runState" :options="options"></td-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item class="paddingLeft10">
                            <td-button type="primary" :loading="loading" :permissions="permissionsQuery" @click="btnQuery">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click="btnAddJob"> {{ $t('common.ADD') }}</td-button>
                            <td-button type="button" :permissions="permissionsEdit" @click="btnStartBatch">{{ $t('common.START_BATCH') }}</td-button>
                            <td-button type="button" :permissions="permissionsEdit" @click="btnStopBatch">{{ $t('common.STOP_BATCH') }}</td-button>
                            <td-button type="button" :permissions="permissionsDel" @click="btnDeleteBatch">{{ $t('common.DELETE_BATCH') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <td-permission :oneOfPermissions="permissionsQuery" style="float:right">
                <div slot="havePermission">
                    <el-tag type="success" solt="dataTips">{{ runningMessage }}</el-tag>
                </div>
            </td-permission>

            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :rowKey="rowKey"
                :hasLoading="hasLoading"
                :permissions="permissionsQuery"
                :dataSource="tableData"
                :hasTreeTable="true"
                :hasPage="false"
                :height="height"
                :selectable="selectable"
                childrenName="children"
                ref="listJobInfo"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-JobInfo
                v-if="dialogAddJobInfoIsible"
                :isAddData="isAddData"
                :dialogAddJobInfoIsible="dialogAddJobInfoIsible"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyJobInfo"
                @jobDialogClose="jobDialogClose"
                @submit="submit"
            ></dialog-JobInfo>
            <dialog-detailInfo
                v-if="dialogDetailIsible"
                :dialogDetailIsible="dialogDetailIsible"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyJobInfo"
                @jobDialogClose="jobDialogClose"
                @submit="submit"
            ></dialog-detailInfo>
        </el-main>
    </el-container>
</template>

<script>
import dialogJobInfo from './components/dialogAddJobInfo.vue';
import dialogDetailInfo from './components/dialogDetailInfo.vue';
import resourceApi from './assets/api.js';

export default {
    // 初始化渲染
    components: {
        'dialog-JobInfo': dialogJobInfo,
        'dialog-detailInfo': dialogDetailInfo
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery(); // 进行页面初始化数据的加载
    },
    data() {
        return {
            // 运行状态数组
            options: [
                {
                    value: this.$common.jobRunState.RUNNING,
                    label: this.$t('common.RUNNING')
                },
                {
                    value: this.$common.jobRunState.WAITTING,
                    label: this.$t('common.WAITTING')
                }
            ],
            height: window.innerHeight - 250,

            fromJob: { jobName: '' },
            runningMessage: '',
            waittingMessage: '',
            editItem: '',
            permissionsQuery: ['timed:view'],
            permissionsDel: ['timed:del'],
            permissionsEdit: ['timed:edit'],
            permissionsAdd: ['timed:add'],
            dialogAddJobInfoIsible: false,
            dialogDetailIsible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            loading: false,
            rowKey: 'jobKey',
            hasLoading: true,
            showCount: true,
            rules: {
                jobName: [{ pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }]
            },
            inputLength: 100,
            columns: [
                {
                    prop: 'jobName',
                    label: 'common.JOB_NAME',
                    tableWidth: '100',
                    showOverflowTooltip: true
                },
                {
                    prop: 'groupName',
                    label: 'common.JOB_GROUP',
                    showOverflowTooltip: true,
                    render: (createElement, params) => {
                        if (params.row.groupName === 'defaultGroup') {
                            return createElement('span', this.$t(''));
                        }
                        return createElement('span', params.row.groupName);
                    }
                },
                {
                    prop: 'jobClassPath',
                    label: 'common.JOB_BEAN_PATH',
                    // tableWidth: '200',
                    showOverflowTooltip: true
                },
                {
                    prop: 'cron',
                    label: 'common.JOB_CRON',
                    align: 'center',
                    // tableWidth: '150',
                    showOverflowTooltip: true
                },
                {
                    prop: 'jobRunTime',
                    label: 'common.JOB_RUNTIME',
                    align: 'center',
                    // tableWidth: '100',
                    showOverflowTooltip: true,

                    render: (createElement, params) => {
                        let minute = 0;
                        let hour = 0;
                        let time = params.row.jobRunTime + 'ms';
                        let second = params.row.jobRunTime / 1000;
                        if (second > 1) {
                            minute = second / 60;
                            time = this.formatFloat(second, 2) + 's';
                        }
                        if (minute > 1) {
                            hour = minute / 60;
                            time = this.formatFloat(minute, 2) + 'min';
                        }
                        if (hour > 1) {
                            time = this.formatFloat(hour, 2) + 'h';
                        }
                        return createElement('span', time);
                    }
                },
                {
                    prop: 'jobAverageTime',
                    label: 'common.JOB_AVERAGE_TIME',
                    align: 'center',
                    showOverflowTooltip: true,
                    // tableWidth: '100',
                    render: (createElement, params) => {
                        let minute = 0;
                        let hour = 0;
                        let time = params.row.jobAverageTime + 'ms';
                        let second = params.row.jobAverageTime / 1000;
                        if (second > 1) {
                            minute = second / 60;
                            time = this.formatFloat(second, 2) + 's';
                        }
                        if (minute > 1) {
                            hour = minute / 60;
                            time = this.formatFloat(minute, 2) + 'min';
                        }
                        if (hour > 1) {
                            time = this.formatFloat(hour, 2) + 'h';
                        }
                        return createElement('span', time);
                    }
                },
                // {
                //     prop: 'jobTotalTime',
                //     label: 'common.JOB_TOTAL_TIME',
                //     align: 'center',
                //     showOverflowTooltip: true,
                //     // tableWidth: '100',
                //     render: (createElement, params) => {
                //         let minute = 0;
                //         let hour = 0;
                //         let time = params.row.jobTotalTime + 'ms';
                //         let second = params.row.jobTotalTime / 1000;
                //         if (second > 1) {
                //             minute = second / 60;
                //             time = this.formatFloat(second, 2) + 's';
                //         }
                //         if (minute > 1) {
                //             hour = minute / 60;
                //             time = this.formatFloat(minute, 2) + 'min';
                //         }
                //         if (hour > 1) {
                //             time = this.formatFloat(hour, 2) + 'h';
                //         }
                //         return createElement('span', time);
                //     }
                // },
                {
                    prop: 'jobState',
                    label: 'common.JOB_STATE',
                    align: 'center',
                    tableWidth: '100',
                    render: (createElement, params) => {
                        let spanLabel = this.$t('common.UNUSING');
                        // spanLabel = this.$t('common.LOADED');
                        let radiusColar = '#fc1414';
                        let spanStyle = 'color:#fc1414';
                        if (params.row.jobState === this.$common.jobRunState.JOB_STATE_START) {
                            spanLabel = this.$t('common.ISUSING');
                            radiusColar = '#08cc69';
                            spanStyle = 'color:#08cc69';
                        }
                        return createElement('div', [
                            // createElement('div', {
                            //     style: {
                            //         borderRadius: '50%',
                            //         background: radiusColar,
                            //         marginLeft: '20px',
                            //         marginTop: '8px',
                            //         width: '8px',
                            //         height: '8px',
                            //         position: 'absolute',
                            //         float: 'left'
                            //     }
                            // }),
                            createElement(
                                'span',
                                {
                                    style: spanStyle
                                },
                                spanLabel
                            )
                        ]);
                    }
                },
                {
                    prop: 'successCount',
                    label: 'common.SUCCESS_COUNIT',
                    align: 'center'
                },
                {
                    prop: 'failedCount',
                    label: 'common.FAILE_COUNIT',
                    align: 'center'
                },
                {
                    prop: 'totalCount',
                    label: 'common.TOTAL_COUNIT',
                    align: 'center'
                },
                {
                    prop: 'persistence',
                    label: 'pgCommon.IS_SYSTEMJOB',
                    align: 'center',
                    render: (createElement, params) => {
                        let label = this.$t('common.NOT');
                        if (params.row.persistence === 1) {
                            label = this.$t('common.YES');
                        }
                        return createElement('span', label);
                    }
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '160',
                    align: 'center',
                    render: (createElement, params) => {
                        let operatioStart = createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnStart(params.row.groupId);
                                        }
                                    }
                                },
                                this.$t('common.JOB_START')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnModify(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsView, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDetail(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DETAIL')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);

                        let operatioStop = createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnStop(params.row.groupId);
                                        }
                                    }
                                },
                                this.$t('common.JOB_STOP')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnModify(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsView, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDetail(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DETAIL')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                        let operatioView = createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsView, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDetail(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DETAIL')
                            )
                        ]);
                        if (params.row.index !== 1) {
                            return '';
                        }
                        if (params.row.jobState === this.$t('common.JOB_STATE_STOP') && params.row.persistence != 2) {
                            return operatioStart;
                        }
                        if (params.row.persistence === 2) {
                            // 只有查看
                            return operatioView;
                        }
                        return operatioStop;
                    }
                }
            ]
        };
    },
    methods: {
        // 添加任务
        btnAddJob() {
            this.$log.info('btnAddJob');
            this.editItem = '';
            this.title = 'common.ADD'; // 标题
            this.isAddData = true;
            this.dialogAddJobInfoIsible = true;
        },
        // 数字格式化
        formatFloat(src, pos) {
            return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
        },
        selectable(row, ind) {
            if (row.index !== 1 || row.persistence == 2) {
                return false;
            } else {
                return true;
            }
        },

        // 查询数据
        btnQuery() {
            this.$log.info('btnQuery');
            this.loading = true;
            let param = {
                jobName: this.fromJob.jobName,
                runState: this.fromJob.runState
            };
            resourceApi.listJobsInfoPage(JSON.stringify(param), response => {
                this.loading = false;
                this.hasLoading = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/timedTaskManager/findJob', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });

                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.tableData = response.data.content;
            });
            this.countRunningJob(this.$common.jobRunState.RUNNING); // 运行中任务数量
        },
        // 任务信息修改
        btnModify(row) {
            this.$log.info('btnModify', row);
            this.editItem = row;
            this.title = 'common.EDIT';
            this.isAddData = false;
            this.dialogAddJobInfoIsible = true;
        },
        btnDetail(row) {
            this.$log.info('btnDetail', row);
            this.editItem = row;
            this.title = 'common.DETAIL';
            this.dialogDetailIsible = true;
        },
        countRunningJob(jobState) {
            let param = {
                jobState: jobState
            };
            resourceApi.countJobByState(param, response => {
                this.$log.info('response', response);
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/timedTaskManager/findJob', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });

                    return;
                }
                let count = response.data.count;
                if (jobState === this.$common.jobRunState.RUNNING) {
                    this.runningMessage = this.$t('common.RUNNING_HOB') + count;
                } else {
                    this.waittingMessage = this.$t('common.WAITTING_JOB') + count;
                }

                this.$log.info('tableData', this.tableData);
            });
        },
        // 任务删除
        btnDelete(row) {
            if (row.persistence === 1) {
                this.$message({ showClose: true, message: this.$t('pgMessage.CURRENT_JOB_CANNOT_DELETE'), type: 'warning' });
                return;
            }
            this.$log.info('btnDelete', row.jobKey);
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { groupId: row.groupId };
                    resourceApi.deleteJob(param, response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                            this.$log.error('timedTaskManager/deleteJob', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message({ showClose: true, message: this.$t('common.UNDELETE'), type: 'info' });
                });
        },
        // 批量删除任务
        btnDeleteBatch() {
            this.$log.info('btnDeleteBatch');
            let ids = this.$refs.listJobInfo.getSelectAllRows();
            let jobKeys = [];
            let notDelJob = [];
            for (let i = 0; i < ids.length; i++) {
                let temValue = ids[i];
                if (temValue.persistence === 1) {
                    notDelJob.push(temValue);
                    continue;
                }
                let jobKey = temValue.groupId;
                jobKeys.push(jobKey);
            }
            if (notDelJob.length > 0) {
                this.$message({ showClose: true, message: this.$t('pgMessage.SELECT_SHSYTEM_JOB'), type: 'warning' });
                return;
            }
            if (jobKeys.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }

            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    resourceApi.deleteBatchGroup(JSON.stringify(jobKeys), response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('timedTaskManager/deleteBatchGroup', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message({ showClose: true, message: this.$t('common.UNDELETE'), type: 'info' });
                });
        },
        // 任务启动
        btnStart(jobKey) {
            this.$log.info('btnStart', jobKey);
            this.$confirm(this.$t('common.JOB_START_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { groupId: jobKey };
                    resourceApi.startJob(param, response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('timedTaskManager/deleteJob', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message({ showClose: true, message: this.$t('common.CANCLE_OPERATION'), type: 'info' });
                });
        },
        // 批量启动任务
        btnStartBatch() {
            this.$log.info('btnStartBatch');
            let jobKeys = this.getGroupKeys();
            if (jobKeys.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });

                return;
            }

            this.$confirm(this.$t('common.JOB_START_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    resourceApi.startJobBatch(JSON.stringify(jobKeys), response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('timedTaskManager/deleteJob', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message({ showClose: true, message: this.$t('common.CANCLE_OPERATION'), type: 'info' });
                });
        },
        // 任务暂停
        btnStop(jobKey) {
            this.$log.info('btnStop', jobKey);
            this.$confirm(this.$t('common.JOB_STOP_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { groupId: jobKey };
                    resourceApi.stopJob(param, response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('timedTaskManager/deleteJob', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message({ showClose: true, message: this.$t('common.CANCLE_OPERATION'), type: 'info' });
                });
        },
        // 获取任务主键
        getJobKeys() {
            let ids = this.$refs.listJobInfo.getSelectAllRows();
            let jobKeys = [];
            for (let i = 0; i < ids.length; i++) {
                let temValue = ids[i];
                let jobKey = temValue.jobKey;
                let keyInfo = {
                    jobkey: jobKey
                };
                jobKeys.push(keyInfo);
            }
            return jobKeys;
        },
        /**
         * 获取选择的所有组id
         */
        getGroupKeys() {
            let ids = this.$refs.listJobInfo.getSelectAllRows();
            let groupIds = [];
            for (let i = 0; i < ids.length; i++) {
                let temValue = ids[i];
                let groupId = temValue.groupId;
                let keyInfo = {
                    groupId: groupId
                };
                groupIds.push(keyInfo);
            }
            return groupIds;
        },
        // 批量停止任务
        btnStopBatch() {
            this.$log.info('btnStopBatch');
            // let ids = this.$refs.listJobInfo.getSelectAllRows();
            let jobKeys = this.getGroupKeys();
            if (jobKeys.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }

            this.$confirm(this.$t('common.JOB_STOP_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    resourceApi.stopJobBatch(JSON.stringify(jobKeys), response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                            this.$log.error('timedTaskManager/stopJobBatch', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message({ showClose: true, message: this.$t('common.CANCLE_OPERATION'), type: 'info' });
                });
        },

        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // dialog关闭调用方法
        jobDialogClose() {
            // this.submit();
            this.dialogAddJobInfoIsible = false;
            this.dialogDetailIsible = false;
        }
    }
};
</script>
